import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { collection, onSnapshot, orderBy, query } from 'firebase/firestore';
import { db } from '../../../../utils/firebase/firebase.utils.js';
import { setSystemNotification } from '../../../../store/system/system.action.js';
import { selectUser } from '../../../../store/user/user.selector.js';

// styles
import {
  SalesInventoryContainer,
  InventoryList,
  EmptyState
} from './SalesInventory.styles.js';

// components
import InventoryItemPanel from './components/inventory-item-panel/InventoryItemPanel.js';
import EditInventoryModal from './components/edit-inventory-modal/EditInventoryModal.js';

export default function SalesInventory() {
  const dispatch = useDispatch();
  const user = useSelector(selectUser);
  const [editItem, setEditItem] = useState(null);
  const [inventoryItems, setInventoryItems] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const handleInventorySnapshot = useCallback((snapshot) => {
    const items = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    setInventoryItems(items);
    setIsLoading(false);
  }, []);

  useEffect(() => {
    if (!user?.uid) {
      setInventoryItems([]);
      setIsLoading(false);
      return;
    }

    setIsLoading(true);
    const inventoryRef = collection(db, `users/${user.uid}/inventory`);
    const inventoryQuery = query(inventoryRef, orderBy('createdAt', 'desc'));

    const unsubscribe = onSnapshot(
      inventoryQuery,
      handleInventorySnapshot,
      (error) => {
        // Error loading inventory
        dispatch(setSystemNotification('Error loading inventory'));
        setIsLoading(false);
      }
    );

    return () => unsubscribe();
  }, [user?.uid, dispatch, handleInventorySnapshot]);


  return (
    <SalesInventoryContainer>
      
      {isLoading && <EmptyState>Loading inventory...</EmptyState>}
      {!isLoading && inventoryItems.length === 0 && (
        <EmptyState>No inventory items yet.</EmptyState>
      )}
      {!isLoading && inventoryItems.length > 0 && (
        <InventoryList>
          {inventoryItems.map((item) => (
            <InventoryItemPanel
              key={item.id}
              item={item}
              onEdit={() => setEditItem(item)}
            />
          ))}
        </InventoryList>
      )}
      <EditInventoryModal
        isOpen={!!editItem}
        item={editItem}
        onClose={() => setEditItem(null)}
      />
    </SalesInventoryContainer>
  )
}